import { render, staticRenderFns } from "./WordSlimView.vue?vue&type=template&id=79d93d05&scoped=true&"
import script from "./WordSlimView.vue?vue&type=script&lang=js&"
export * from "./WordSlimView.vue?vue&type=script&lang=js&"
import style0 from "./WordSlimView.vue?vue&type=style&index=0&id=79d93d05&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d93d05",
  null
  
)

export default component.exports